<template>
  <div class="search_list search_list_border">
    <header v-show="showTitle" class="search-title">
      <span><svg-icon :icon-class="icons" class="icon-search" />{{ title }}</span>
    </header>
    <div :class="['search_content',custromClass]">
      <slot name="content" />
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '快速查询'
    },
    custromClass: {
      type: String,
      default: ''
    },
    icons: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>

.search_list_border{
//  border: 1px solid rgba(0,0,0,.1);
 background: #ffffff;
 .search_content{
   padding: 12px 10px;
 }

}
.search-title{
  padding: 12px 15px 0 15px;
  font-size: 12px;
  color: #515c60;
  // border-bottom: 1px solid rgba(0,0,0,.1);
  span{
    font-size: 12px;
    font-weight: bold;
  }
}
.icon-search{
  margin-right: 10px;
}
</style>
